import TrackableLink from "./TrackableLink";

const TalkToAnSCESpecialist = ({ linkProps }: { linkProps?: Partial<React.ComponentProps<typeof TrackableLink>> }) => (
  <TrackableLink
    event="Talk to an SCE Specialist"
    category="Clicked to speak to EV Specialist"
    href={`mailto:TCO@sce.com?subject=SCE Fleets inquiry via ${window.location.hostname}`}
    className="btn btn-success bold text-white rounded-0"
    {...linkProps}
  >
    Talk to an SCE Specialist
  </TrackableLink>
);

export default TalkToAnSCESpecialist;
